@if (showContent()) {
	<div
		#overlay
		class="bottom-sheet-overlay"
		data-cy="bottom-sheet-overlay"
		aria-hidden="true"
		(click)="onBackdropClick($event)"></div>

	<div
		#bottomSheet
		class="bottom-sheet-panel"
		data-cy="bottom-sheet-panel"
		swipeUpDown
		role="dialog"
		aria-roledescription="bottom sheet"
		[class.disable-hide]="backdrop() !== true"
		[attr.aria-modal]="true"
		[attr.aria-label]="ariaLabel() || title() || undefined"
		[attr.aria-labelledby]="ariaLabelledBy() || undefined"
		[attr.aria-describedby]="ariaDescribedBy() || undefined"
		(click)="onPanelClick($event)"
		(swipeHide)="onSwipeHide()">
		@if (showTopHandle()) {
			<div class="flex justify-center" aria-hidden="true">
				<ui-icon width="32" height="32" class="text-gray-300" iconName="bs-center" />
			</div>
		}

		@if (bottomSheetHeader() || title()) {
			<header class="bottom-sheet-header {{ headerClass() }}">
				@if (bottomSheetHeader(); as header) {
					<ng-container *ngTemplateOutlet="header" />
				} @else if (title()) {
					<h2 class="w-full text-center text-base font-bold text-gray-900" [id]="ariaLabelledBy()">
						{{ title() }}
					</h2>
				}
			</header>
		}

		@if (bottomSheetBody(); as body) {
			<div class="bottom-sheet-body {{ bodyClass() }}">
				<ng-container *ngTemplateOutlet="body" />
			</div>
		}

		@if (bottomSheetFooter(); as footer) {
			<footer class="bottom-sheet-footer {{ footerClass() }}">
				<ng-container *ngTemplateOutlet="footer" />
			</footer>
		}
	</div>
}
